import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "name" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Mike", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Gecawicz", -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "tagLine" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Software Developer & Digital Content Designer", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Based in Raleigh, NC", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "mainContent" }
const _hoisted_11 = { class: "column1" }
const _hoisted_12 = { class: "blogDate" }
const _hoisted_13 = { class: "blogContent" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_15 = { class: "column2" }
const _hoisted_16 = { style: {"line-height":"0.3"} }
const _hoisted_17 = { class: "dummy" }
const _hoisted_18 = { class: "dummy" }
const _hoisted_19 = { class: "code-container" }

import "./style/home.css";
import blog from "../data/blog.json";
import code from "raw-loader!../data/homevue.txt";

import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "HomeView",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_highlightjs = _resolveComponent("highlightjs")!
  const _directive_motion_slide_visible_once_left = _resolveDirective("motion-slide-visible-once-left")!
  const _directive_motion_slide_visible_once_bottom = _resolveDirective("motion-slide-visible-once-bottom")!
  const _directive_motion_slide_visible_once_right = _resolveDirective("motion-slide-visible-once-right")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createElementBlock("h1", null, _hoisted_5)), [
        [_directive_motion_slide_visible_once_left]
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9)), [
      [_directive_motion_slide_visible_once_bottom]
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(blog).entries, (entry) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", { key: entry }, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(entry.date), 1),
            _createElementVNode("p", _hoisted_13, _toDisplayString(entry.content), 1),
            _hoisted_14
          ])), [
            [_directive_motion_slide_visible_once_left]
          ])
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_17, [
            _createTextVNode(" This website was developed using Vue.js ")
          ])), [
            [_directive_motion_slide_visible_once_right]
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_18, [
          _createTextVNode(" Here's the code for this page... ")
        ])), [
          [_directive_motion_slide_visible_once_right]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_highlightjs, {
            class: "code-block",
            language: "javascript",
            code: _unref(code)
          }, null, 8, ["code"])
        ])), [
          [_directive_motion_slide_visible_once_right]
        ])
      ])
    ])
  ], 64))
}
}

})